import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import * as momentBusinessDays from 'moment-business-days';
import * as moment from 'moment';
import 'moment-timezone';
import { DarkModeService } from './dark-mode.service';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  public static NG_SELECT_ALL_ITEMS_ELEMENT = 'All items';

  static getNYTime() {
    return moment();
  }

  static getNYTimeByDate(date: Date) {
    return moment(date).tz('America/New_York');
  }

  static getLast3BusinessDays(): Date {
    return momentBusinessDays(new Date(), 'DD-MM-YYYY')
      .prevBusinessDay()
      .prevBusinessDay()
      .toDate();
  }

  static getLast7BusinessDays(): Date {
    return momentBusinessDays(new Date(), 'DD-MM-YYYY')
      .prevBusinessDay()
      .prevBusinessDay()
      .prevBusinessDay()
      .prevBusinessDay()
      .prevBusinessDay()
      .prevBusinessDay()
      .toDate();
  }

  static minArrayLength(min: number) {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value !== null && control.value.length < min) {
        return { minArrayLengthValidator: true };
      }
      return null;
    };
  }

  static passwordsMatched() {
    return (form: UntypedFormGroup): { [key: string]: boolean } | null => {
      const newPassword = form.get('newPassword');
      const newPasswordAgain = form.get('newPasswordAgain');
      if (newPassword.value !== newPasswordAgain.value) {
        return {
          passwordsMatched: false,
        };
      }
      return null;
    };
  }

  public static getFirstCCY(instrument: string) {
    if (instrument.includes('/')) {
      return instrument.split('/')[0];
    }
    return instrument.substring(0, 3);
  }

  public static getSecondCCY(instrument: string) {
    if (instrument.includes('/')) {
      return instrument.split('/')[1];
    }
    return instrument.substring(3, 6);
  }

  public static isNotUndefinedOrNull(value: unknown) {
    return value !== undefined && value !== null;
  }

  public static isUndefinedOrNull(value: unknown) {
    return value === undefined || value === null;
  }

  public static isNotZero(value: number) {
    return value !== 0;
  }

  public static isNotNullOrUndefinedOrZero(value: number) {
    return (
      UtilsService.isNotUndefinedOrNull(value) && UtilsService.isNotZero(value)
    );
  }

  public static getModalDarkModeClass(darkModeService: DarkModeService) {
    return darkModeService.isDarkModeOn() ? ' dark-skin' : '';
  }
}
